import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import MetaTitle from '../components/documenuts/MetaTitle'

const PageNotFound = () => {
    return (
        <>
            <section className="page_404">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 ">
                            <div className="col-sm-10 mx-auto text-center">
                                <div className="four_zero_four_bg">
                                    <h1 className="text-center ">404</h1>
                                </div>

                                <div className="contant_box_404">
                                    <h3 className="h2">
                                        Lehte ei eksisteeri
                                    </h3>
                                    <Link to="/" className="link_404">
                                        Tagasi avalehele
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>

    )
}

export default PageNotFound